import { render, staticRenderFns } from "./PinFloorplan.vue?vue&type=template&id=a15bc048&"
import script from "./PinFloorplan.vue?vue&type=script&lang=js&"
export * from "./PinFloorplan.vue?vue&type=script&lang=js&"
import style0 from "./PinFloorplan.vue?vue&type=style&index=0&id=a15bc048&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports